import { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router';
import { useAuth } from '../../auth';
import { ROUTES, ROLE_LABELS } from '../../constants';
import { initials } from '../../utils/format';
import { DeluxeLogo } from '../common/DeluxeLogo';

export function TopBar() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [anchor, setAnchor] = useState<null | HTMLElement>(null);

    function handleLogout() {
        setAnchor(null);
        logout();
        void navigate(ROUTES.LOGIN, { replace: true });
    }

    const roleLabel = user?.roles.length ? user.roles.map((r) => ROLE_LABELS[r]).join(', ') : '';

    return (
        <AppBar
            position="sticky"
            elevation={0}
            sx={{
                bgcolor: 'background.paper',
                borderBottom: 1,
                borderColor: 'divider',
                color: 'text.primary',
                zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
        >
            <Toolbar sx={{ minHeight: 56 }}>
                <Box sx={{ flexGrow: 1 }}>
                    <DeluxeLogo iconSize={26} layout="inline" />
                </Box>

                {user && (
                    <>
                        <Typography variant="caption" color="text.secondary" sx={{ mr: 1 }}>
                            {roleLabel}
                        </Typography>
                        <IconButton
                            size="small"
                            onClick={(e) => {
                                setAnchor(e.currentTarget);
                            }}
                            aria-label="user menu"
                        >
                            <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main', fontSize: 13 }}>
                                {initials(user.name)}
                            </Avatar>
                        </IconButton>
                        <Menu
                            anchorEl={anchor}
                            open={Boolean(anchor)}
                            onClose={() => {
                                setAnchor(null);
                            }}
                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                        >
                            <MenuItem disabled>
                                <ListItemIcon>
                                    <PersonIcon fontSize="small" />
                                </ListItemIcon>
                                <Typography variant="body2">
                                    {user.name}
                                    <Typography
                                        component="span"
                                        variant="caption"
                                        color="text.secondary"
                                        sx={{ display: 'block' }}
                                    >
                                        {user.email}
                                    </Typography>
                                </Typography>
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={handleLogout}>
                                <ListItemIcon>
                                    <LogoutIcon fontSize="small" />
                                </ListItemIcon>
                                Sign out
                            </MenuItem>
                        </Menu>
                    </>
                )}
            </Toolbar>
        </AppBar>
    );
}
